import { defineMessages } from 'react-intl';

export default defineMessages({
	errorTitle: {
		defaultMessage: 'Error',
		description: 'Title of the error panel shown when a request types post has failed.',
		id: 'cv.request.create.form.multiservicepickerv2.usepaginatedservice.error.title',
	},
	errorDescription: {
		defaultMessage: "We couldn't load the affected services. Refresh the page and try again.",
		description: 'Description of the error panel shown when an affected services fetch has failed.',
		id: 'cv.request.create.form.multiservicepickerv2.usepaginatedservice.error.description',
	},
});
